import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  signInAnonymously,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAj4BkM3RrqFCF0mndBnl7XBrmN2_j_t5I",
  authDomain: "mini-project-b47fe.firebaseapp.com",
  projectId: "mini-project-b47fe",
  storageBucket: "mini-project-b47fe.appspot.com",
  messagingSenderId: "513168870442",
  appId: "1:513168870442:web:37123f20ac01381bde8753",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => {
  signInWithPopup(auth, provider);
};
export const signOutFromGoogle = () => {
  signOut(auth, provider);
};
// export const signInAsGuest = () => {
//   signInAnonymously(auth, provider);
// };
export const db = getFirestore(app);
